import type { ScheduleBar } from '../types.js';

/**
 * 386 slice 2 (#1278, FR-012, the approved mock-up): where a car's gap between rentals is shaded. One shade of `b`
 * minutes after each rental that HOLDS the car (a committed booking or extension leg), after its last held leg only —
 * never after an unpaid booking, a lapsed hold, an unheld booking or a staff block. A rental is its root booking and
 * its extension legs (`root_booking_id ?? booking_id`).
 */
export interface GapShade {
  /** The rental's root booking id. */
  key: string;
  start: number;
  end: number;
}

const RENTAL_KINDS = new Set(['booking', 'extension']);

export function gapShades(bars: readonly ScheduleBar[], bufferMinutes: number): GapShade[] {
  if (bufferMinutes <= 0) return [];
  const lastEnd = new Map<string, number>();
  for (const bar of bars) {
    if (!RENTAL_KINDS.has(bar.kind) || bar.state !== 'committed' || !bar.booking_id) continue;
    const key = bar.root_booking_id ?? bar.booking_id;
    const end = Date.parse(bar.end_at);
    if (end > (lastEnd.get(key) ?? Number.NEGATIVE_INFINITY)) lastEnd.set(key, end);
  }
  return [...lastEnd].map(([key, end]) => ({ key, start: end, end: end + bufferMinutes * 60_000 }));
}
